import { createPermission } from '@backstage/plugin-permission-common';

// NO MODIFICAR ESTA CLASE

export interface UserInfo {
  userId: string;
  groups: string[];
}

export const runtest = createPermission({
  name: 'grievous.runtest.read',
  attributes: {},
})
export const myLogs = createPermission({
  name: 'grievous.mylogs.read',
  attributes: {},
})
export const tokenGen = createPermission({
  name: 'grievous.token.read',
  attributes: {},
})
export const cronjobs = createPermission({
  name: 'grievous.cronjobs.read',
  attributes: {},
})
export const configuration = createPermission({
  name: 'grievous.configuration.read',
  attributes: {},
})

export const grievousPermissions = [
  runtest,
  myLogs,
  tokenGen,
  cronjobs,
  configuration
]
